import React from 'react';
import { connect } from 'react-redux';
import Thread from 'Components/threads/ThreadComponent';
import { push } from 'react-router-redux';

import { pathToThread } from 'Utils/nav/NavHelpers';

import forumViewSelector from 'Selectors/forumViewSelector';

class StickyThreadListComponent extends React.Component {
	gotoThread = (id) => {
		this.props.dispatch( push( pathToThread(id) ) );
	};

	buildTopic = (key, topic, users) => {
		return (
			<li key={ `sticky_${key}` } onClick={ () => this.gotoThread( topic.id ) }>
				<Thread
					thread={ topic }
					isSubscribable={ true }
					user={ users[topic.forumUser] }
					users={ users }
					dispatch={ this.props.dispatch }
					ustate={ this.props.ustate }
					selectedElements={ this.props.meta.selectedElements }
				/>
			</li>
		);
	};

	render() {
		const {entities: {users, sticky}, result} = this.props.forumview;

		if( result.sticky.length === 0 ) {
			return null
		}

		const stickyList = result.sticky.map( ( k, i ) => this.buildTopic( i, sticky[ k ], users ) );

		return (
			<div className="threads sticky">
				<div className="list-summary">
					Sticky Topics ( { result.sticky.length } Topic{ result.sticky.length === 1 ? '' : 's' } )
				</div>
				<ul>
					{ stickyList }
				</ul>
			</div>
		);
	}
}

export default connect(forumViewSelector)(StickyThreadListComponent);


// WEBPACK FOOTER //
// ./src/components/threads/StickyThreadListComponent.js